import Post1 from './Post1';

export default Post1;
